import moment from "moment";

export let getEvents = () => {
  return (dispatch) => {
    fetch(
      `https://www.googleapis.com/calendar/v3/calendars/g2sns9li7vvr4m8tlkuke6rkr0%40group.calendar.google.com/events?key=AIzaSyAi1rp1LuVZBdZzNLpEnWqOJyN7Wodnt9c&orderBy=startTime&singleEvents=true&timeMin=${moment().toISOString()}`,
    )
      .then((response) => {
        if (response.status !== 200) {
          return Promise.reject();
        }
        return response.json();
      })
      .then((json) => {
        dispatch({
          type: "EVENTS_UPDATE",
          payload: {
            ...json,
            fetched: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: "EVENTS_UPDATE",
          payload: {
            fetched: true,
            error: error,
          },
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/scenes/landingPage/components/events/services/eventsActions.js